import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_4fd03dcd";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_4fd03dcd" };
/** script content **/
require("./swipe-item.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex4fd03dcd%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fswipe-item%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_4fd03dcd"],
    ctorType: "component",
    outputPath: "components/index4fd03dcd/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
